<svg
  xmlns="http://www.w3.org/2000/svg"
  [attr.width]="width"
  [attr.height]="height"
  viewBox="0 0 24 24"
  fill="none"
  focusable="false"
  aria-hidden="true"
>
  <path
    [attr.fill]="color"
    d="M17 20.056a1 1 0 0 1-1.581.815l-5.165-3.69L17 11.932v8.123ZM15.419 3.13A1 1 0 0 1 17 3.943V9.4L7.229 17H7a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h3l5.419-3.87Z"
  />
  <path [attr.stroke]="color" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 5 3 19" />
</svg>
